export default function getDeviceInformation() {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ data: "device" }));
  }
}
